import createActionHandlers from '@sift/resift/redux/FetchUtils/createActionHandlers';
import { mergeSuccess } from '@sift/resift/redux/FetchUtils';

// ------------------------------------
// Constants
// ------------------------------------
export const DIRECTORY_CREATE_IDENTIFIER = 'directory-create';

export const DIRECTORIES_FETCH = 'DIRECTORIES_FETCH';
export const DIRECTORIES_FETCH_SUCCESS = 'DIRECTORIES_FETCH_SUCCESS';
export const DIRECTORIES_FETCH_ERROR = 'DIRECTORIES_FETCH_ERROR';

export const DIRECTORY_FETCH = 'DIRECTORY_FETCH';
export const DIRECTORY_FETCH_SUCCESS = 'DIRECTORY_FETCH_SUCCESS';
export const DIRECTORY_FETCH_ERROR = 'DIRECTORY_FETCH_ERROR';

export const DIRECTORY_CREATE = 'DIRECTORY_CREATE';
export const DIRECTORY_CREATE_SUCCESS = 'DIRECTORY_CREATE_SUCCESS';
export const DIRECTORY_CREATE_ERROR = 'DIRECTORY_CREATE_ERROR';

export const DIRECTORY_DELETE = 'DIRECTORY_DELETE';
export const DIRECTORY_DELETE_SUCCESS = 'DIRECTORY_DELETE_SUCCESS';
export const DIRECTORY_DELETE_ERROR = 'DIRECTORY_DELETE_ERROR';

export const DIRECTORY_SAVE = 'DIRECTORY_SAVE';
export const DIRECTORY_SAVE_SUCCESS = 'DIRECTORY_SAVE_SUCCESS';
export const DIRECTORY_SAVE_ERROR = 'DIRECTORY_SAVE_ERROR';

// ------------------------------------
// Actions
// ------------------------------------

export function fetchDirectories(query) {
  return {
    type: DIRECTORIES_FETCH,
    identifier: 'directories',
    payload: {
      query,
    },
  };
}

export function fetchDirectory(directoryId, expands) {
  const query = {};

  if (expands) {
    query.expand = Array.isArray(expands) ? expands : [expands];
  }

  return {
    type: DIRECTORY_FETCH,
    identifier: directoryId,
    payload: {
      id: directoryId,
      query: expands ? query : undefined,
    },
  };
}

export function createDirectory(label) {
  return {
    type: DIRECTORY_CREATE,
    identifier: DIRECTORY_CREATE_IDENTIFIER,
    payload: {
      data: {
        label,
      },
    },
  };
}

export function deleteDirectory(id) {
  return {
    type: DIRECTORY_DELETE,
    identifier: `directory-delete`,
    payload: {
      id,
    },
  };
}

export function saveDirectory(directory) {
  return {
    type: DIRECTORY_SAVE,
    identifier: `save-${directory.id}`,
    payload: {
      data: directory,
    },
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  ...createActionHandlers(DIRECTORY_FETCH, false),
  ...createActionHandlers(DIRECTORY_CREATE, false),
  ...createActionHandlers(DIRECTORY_SAVE, false),
  [DIRECTORY_SAVE_SUCCESS]: (state, action) => {
    const updatedDirectory = action.payload.data;
    const oldDirectory = state.objects[updatedDirectory.id];
    const directory = {
      ...oldDirectory,
      ...updatedDirectory,
      settings: {
        ...oldDirectory.settings,
        ...updatedDirectory.settings,
      },
    };

    return {
      ...mergeSuccess(state, action),
      objects: {
        ...state.objects,
        [updatedDirectory.id]: {
          ...directory,
        },
      },
    };
  },
  ...createActionHandlers(DIRECTORY_DELETE, true),
  ...createActionHandlers(DIRECTORIES_FETCH, false),
};

// ------------------------------------
// Reducer
// ------------------------------------

export const initialState = {
  fetches: {},
  objects: {},
};
export default function directoriesReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
